import Vue from 'vue'
import VueRouter from 'vue-router'
import {
	permission
} from './permission';

Vue.use(VueRouter)

const routes = [{
		path: '/',
		redirect: '/index'
	},
	{
		path: '/index',
		name: 'index',
		component: () => import('@/views/index/index.vue'),
	},
	// 下单页面
	{
		path: '/home',
		name: 'home',
		component: () => import('@/views/home/index.vue'),
		redirect: 'shopping',
		children: [{
				path: '/shopping',
				name: 'shopping',
				component: () => import('@/views/home/shopping/index.vue'),
			},
			{
				path: '/history',
				name: 'history',
				component: () => import('@/views/home/history/index.vue'),
			},

			{
				path: '/historytwo',
				name: 'historytwo',
				component: () => import('@/views/home/historytwo/index.vue'),
			}
		]
	},
	// 店铺页面
	{
		path: '/shop',
		name: 'shop',
		component: () => import('@/views/shop/shopView.vue')
	},
	{
		path: '/pay',
		name: 'pay',
		component: () => import('@/views/pay/index.vue')
	},
	// 城市页面
	{
		path: '/city',
		name: 'city',
		component: () => import('@/views/shop/cityView.vue')
	},
	// 购物车
	{
		path: '/shoppingcart',
		name: 'shoppingcart',
		component: () => import('@/views/shoppingCart/shoppingCartView.vue')
	},
	// 下单页面
	{
		path: '/order',
		name: 'order',
		component: () => import('@/views/order/orderView.vue')
	},
	// 订单详情
	{
		path: '/orderDtl',
		name: 'orderDtl',
		component: () => import('@/views/orderDtl/orderDtlView.vue')
	},
	//商品详情
	{
		path: '/goodsInfo',
		name: 'goodsInfo',
		component: () => import('@/views/goods/goodsView.vue')
	},
	//口令界面
	{
		path: '/code',
		name: 'code',
		component: () => import('@/views/code/index.vue')
	},
	//二维码
	{
		path: '/qrcode',
		name: 'qrcode',
		component: () => import('@/views/qrcode/index.vue')
	},
	{
		path: '/binding',
		name: 'binding',
		component: () => import('@/views/binding/index.vue')
	},


	//404
	{
		path: "*",
		redirect: '/index'
	}
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})

// 权限
permission(router);

export default router
